import type { BffApiClient } from "@/app/api-client"
import type { UnionAddress } from "@anaconda/core/blockchain/address"
import type { Blockchain } from "@anaconda/core/blockchain/types"

export const getUserBidsQueryParams = (
  apiClient: BffApiClient,
  queryInput: {
    address: UnionAddress
    blockchains: Blockchain[]
  },
) => ({
  queryKey: ["user", "bids", queryInput],
  queryFn: async ({ pageParam }: { pageParam?: string }) => {
    const response = await apiClient.api.profile[":address"].bids.$post({
      param: { address: queryInput.address },
      json: {
        cursor: pageParam,
        size: 30,
        blockchains: queryInput.blockchains,
      },
    })

    if (!response.ok) throw await response.json()

    return response.json()
  },
  initialPageParam: undefined,
  getNextPageParam: (lastPage: { cursor?: string }) => {
    return lastPage.cursor
  },
})
